import Vue from 'vue'
// @ts-ignore
import NoSsr from 'vue-no-ssr'
import { CURRENCIES } from '@/constants/currency'
import { JOB_ADD, JOB_EDIT } from '@/constants/routes'
import rolebleMixin from '@/mixins/rolebleMixin'
import shareableMixin from '@/mixins/shareableMixin'
import BookmarkButton from '@/partials/BookmarkButtons/BookmarkButton/BookmarkButton.vue'
import PreferredCurrencies from '@/partials/PreferredCurrencies/PreferredCurrencies.vue'
import { formatDate, getDiff } from '@/utils/date'
import { formatUsd } from '@/utils/moneyFormat'
import jobActionsMixin from '../jobActionsMixin'

export default Vue.extend<any, any, any, any>({
  mixins: [rolebleMixin, jobActionsMixin, shareableMixin],
  components: {
    BookmarkButton,
    NoSsr,
    PreferredCurrencies,
  },
  data() {
    return {
      JOB_ADD,
      JOB_EDIT,
    }
  },
  computed: {
    hasDelivery() {
      return !!this.job.delivery_time_at
    },
    daysLeft() {
      const days = Math.max(getDiff(this.job.delivery_time_at, Date.now(), 'day'), 0)
      return days === 1 ? `${days} day` : `${days} days`
    },
    deliveryFormat() {
      return formatDate(this.job.delivery_time_at, 'MMM Do, YYYY')
    },
    budget() {
      return formatUsd(this.job.budget)
    },
    jobCurrencies() {
      return CURRENCIES || []
    },
  },
})
